import React, { useRef } from 'react';
import { InView } from 'react-intersection-observer';

var ScrollWaypoint = function ScrollWaypoint(props) {
  var enabled = props.enabled,
      children = props.children,
      viewportMargin = props.viewportMargin,
      threshold = props.threshold;
  var eventKey = props.eventKey,
      onEnter = props.onEnter,
      onLeave = props.onLeave,
      afterEnterOptions = props.afterEnterOptions;
  var inViewPort = useRef(false);
  var afterEnterTimeout = useRef();

  var resolveWaypoint = function resolveWaypoint(inViewPortRechecked, _entry) {
    if (inViewPort.current && !inViewPortRechecked && enabled) {
      if (onLeave) onLeave(eventKey);

      if (afterEnterTimeout.current) {
        clearTimeout(afterEnterTimeout.current);
      }
    }

    if (!inViewPort.current && inViewPortRechecked && enabled) {
      onEnter(eventKey);

      if (afterEnterOptions) {
        afterEnterTimeout.current = setTimeout(function () {
          afterEnterOptions.afterEnter(eventKey);
        }, afterEnterOptions.delay);
      }
    }

    inViewPort.current = inViewPortRechecked;
  };

  return /*#__PURE__*/React.createElement(InView, {
    as: "div",
    onChange: resolveWaypoint,
    rootMargin: viewportMargin,
    threshold: threshold ? threshold : 0.95
  }, children);
};

export default ScrollWaypoint;
//# sourceMappingURL=ScrollWayPoint.esm.js.map
